import { requestHelpers } from '../../helpers';

const actions = {
    GET_DOCUMENTS: 'GET_DOCUMENTS',
    SET_DOCUMENTS: 'SET_DOCUMENTS',
};

function getDocuments( networkId, options, page ) {

    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_DOCUMENTS,
            networkId,
        } );

        let newOptions;

        if( !options || options === null ) {
            newOptions = options = {};
        } else {
            newOptions = { ...options };
        }

        // newOptions.network_id = networkId;

        if( !page ) {
            newOptions.page = 1;
        }else {
            newOptions.page = page;
        }

        requestHelpers
            .authenticatedGetRequest( '/documents', newOptions )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_DOCUMENTS,
                    documents: response.data,
                    pagination: response.meta,
                    options,
                } );
            } );
    }
}

function downloadDocument( documentId ) {

    return ( dispatch ) => {
        requestHelpers
            .authenticatedPostRequest( `/documents/${ documentId }/download`, null )
            .then( ( response ) => {
                dispatch( {

                } );
            } );
    }
}

module.exports = {
    actions,
    getDocuments,
    downloadDocument,
};



// WEBPACK FOOTER //
// src/client/actions/documents/documents.js